import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import ContentItems from 'umg-ember-backend/components/page-builder/content-items';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../../styles.module.css';

const bem = getBem(styles);

export default class PageBuilderContentItemsItemForPageBuilderLink extends Component {
  // Services
  @service pageBuilderFrontendApi;

  // Getter and setter
  get allowToAddColumn() {
    return this.args.contentItem.children.length < 1;
  }

  get linkConfig() {
    return this.themeConfig?.cms?.['link'];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <div class={{bem 'content'}} ...attributes>
      <h3 class={{bem 'title'}}>
        {{@contentItem.displayHeadline}}
        {{#if @contentItem.contentItemId}}
          ({{@contentItem.contentItemId}})
        {{/if}}
      </h3>
      <ContentItems
        @contentItems={{@contentItem.children}}
        @contentItemTypeOptions={{this.linkConfig.contentItems}}
        @direction='y'
        @isDisabled={{@isDisabled}}
        @isSelectAllowed={{this.allowToAddColumn}}
        @mlp={{@mlp}}
        @onSelectContentItem={{@onSelectContentItem}}
        @onSaveMlp={{@onSaveMlp}}
        @parent={{@contentItem}}
        @selectedContentItem={{@selectedContentItem}}
      />
    </div>
  </template>
}
